import { render, staticRenderFns } from "./SpendHubText.vue?vue&type=template&id=4bbfbae6&"
import script from "./SpendHubText.vue?vue&type=script&lang=js&"
export * from "./SpendHubText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports